import * as Tooltip from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  content: ReactNode;
  size?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export function InfoTooltip({ content, size = 11, side = 'top' }: Props) {
  return (
    <Tooltip.Provider delayDuration={120}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            tabIndex={-1}
            aria-label="Mas informacion"
            className="inline-flex h-4 w-4 items-center justify-center rounded-full"
            style={{ color: 'var(--text-muted)' }}
          >
            <Info size={size} strokeWidth={1.8} />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            sideOffset={6}
            collisionPadding={8}
            className="z-50 max-w-xs rounded-[var(--radius-sm)] border px-3 py-2 text-[11px] shadow-lg"
            style={{
              background: 'var(--surface-1)',
              borderColor: 'var(--border-default)',
              color: 'var(--text-secondary)',
              lineHeight: 1.45,
            }}
          >
            {content}
            <Tooltip.Arrow className="fill-[var(--surface-1)]" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
